// ActivityFeedRow — one activity_log row (colored dot + description +
// time-ago). Shared by the dashboard's activity feed card and the full
// ActivityPage. ActivitySkeletonRow is the loading placeholder for both.
import { formatTimeAgo } from "../../lib/timeAgo.js";
import type { ActivityEventType } from "@dm-lms/shared/types";

// Exported — the full admin ActivityPage table reuses these exact colors.
export const DOT_COLOR: Partial<Record<ActivityEventType, string>> = {
  "enrollment.created":        "bg-green-500",
  "certificate.issued":        "bg-green-500",
  "tutor.approved":            "bg-green-500",
  "student.profile_completed": "bg-green-500",
  "payment.received":          "bg-blue-500",
  "payment.confirmed":         "bg-blue-500",
  "session.created":           "bg-blue-500",
  "course.updated":            "bg-blue-500",
  "attendance.checked_in":     "bg-blue-500",
  "tutor.applied":             "bg-amber-500",
  "student.registered":        "bg-amber-500",
  "payment.failed":            "bg-red-500",
  "tutor.rejected":            "bg-red-500",
};

interface ActivityFeedRowProps {
  eventType: ActivityEventType;
  description: string;
  createdAt: string;
}

export default function ActivityFeedRow({ eventType, description, createdAt }: ActivityFeedRowProps) {
  return (
    <div className="flex items-start gap-3 py-2.5">
      <span className={`mt-1.5 h-2 w-2 shrink-0 rounded-full ${DOT_COLOR[eventType] ?? "bg-gray-400"}`} />
      <div className="min-w-0 flex-1">
        <p className="text-sm text-dm-navy">{description}</p>
        <p className="text-xs text-dm-slate">{formatTimeAgo(createdAt)}</p>
      </div>
    </div>
  );
}

export function ActivitySkeletonRow() {
  return (
    <div className="flex animate-pulse items-start gap-3 py-2.5">
      <span className="mt-1.5 h-2 w-2 shrink-0 rounded-full bg-gray-200" />
      <div className="flex-1 space-y-1.5">
        <div className="h-3 w-3/4 rounded bg-gray-200" />
        <div className="h-2.5 w-1/4 rounded bg-gray-200" />
      </div>
    </div>
  );
}
